import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="bg-white border-4 border-brand-gold/40 p-5 sm:p-6 rounded-xl text-center shadow-lg" data-id="element-85">
          <p className="text-xs sm:text-sm font-extrabold text-brand-petrol uppercase tracking-widest mb-2" data-id="element-86">
            YOUR INVESTMENT IS 100% PROTECTED
          </p>
          <div className="w-14 h-14 mx-auto bg-brand-petrol/10 rounded-full flex items-center justify-center mb-2" data-id="element-87">
            <ShieldCheck className="w-7 h-7 text-brand-petrol" data-id="element-88" />
          </div>
          <h3 className="text-xl sm:text-2xl font-serif font-extrabold text-brand-graphite mb-3 uppercase" data-id="element-89">
            🛡️ 7-Day Money-Back Guarantee
          </h3>
          <div className="text-sm sm:text-base text-brand-graphite/90 font-medium max-w-2xl mx-auto leading-snug space-y-2" data-id="element-90">
            <p data-id="element-91">Your purchase is completely risk-free.</p>
            <p data-id="element-92">
              Take seven full days to explore the entire system, review every
              module, customize the templates, organize your consultation
              workflow, and start using the professional resources with your
              clients.
            </p>
            <p data-id="element-93">
              If for any reason you're not completely satisfied, simply contact
              us within the first 7 days and we'll refund 100% of your purchase.
            </p>
            <p className="font-bold text-brand-petrol uppercase tracking-wide" data-id="element-94">
              No risk. No questions asked.
            </p>
          </div>
        </div>
      </div>
    </section>;
}